// SEQ-199: what the grid says when its monthly figures fail to load, by kind of failure,
// so the viewer is told whose fault it is and what to do (standard 6.1). The raw error
// string is never shown: it can carry server detail.

export type GridErrorKind = "session" | "connection" | "server";

export function gridErrorKind(message: string | null | undefined): GridErrorKind {
  const text = message ?? "";
  if (/statement timeout|canceling statement|connection slots|too many clients|pooler/i.test(text)) return "server";
  if (/\bjwt\b|invalid (token|jwt)|not authenticated|unauthori[sz]ed|status:? ?401|\(401\)/i.test(text)) return "session";
  if (/failed to fetch|network|load failed|abort|offline|timeout|timed out/i.test(text)) return "connection";
  return "server";
}

const REASON: Record<GridErrorKind, string> = {
  session: "Your session may have expired. Reload the page to sign in again.",
  connection: "This looks like a connection problem. Check your connection, then try again.",
  server: "Our server could not return them. Try again, or reload the page if it keeps failing.",
};

/** First load failed: nothing to show. */
export function gridLoadErrorCopy(message: string | null | undefined): string {
  return `We could not load the monthly figures. ${REASON[gridErrorKind(message)]}`;
}

/** A refresh failed after a table had loaded: the table stays, so say so. */
export function gridRefreshErrorCopy(message: string | null | undefined): string {
  return `We could not refresh the monthly figures, so the table below is the last version that loaded. ${REASON[gridErrorKind(message)]}`;
}
